<!-- <div>
Käytettävä valmiusprosenttialgoritmi
<mat-radio-group [formControl]="valmiusprosenttiAlgoFormControl" style="margin-left: 10px;">
  <mat-radio-button value="v">Vanha</mat-radio-button>
  <mat-radio-button value="u" style="margin-left: 10px">Uusi</mat-radio-button>
</mat-radio-group>
</div> -->

@if (sarakevalinnatAukiObservable | async) {
  <div style="margin-bottom: 16px">
    <div style="display: flex; flex-flow: row wrap">
      @for (sarake of kaikkiSarakkeetObservable | async; track sarake.avain) {
        <app-button (click)="muokkaaSaraketta(sarake)" [dynamicClass]="{ 'dark-gray-text': !sarake.aktiivinen, 'light-blue-text': sarake.aktiivinen }" (contextmenu)="openSarakeContextMenu($event, sarakeContextMenuTrigger, sarakeMenuTrigger, sarake)" actionId="Muokkaa saraketta tai avaa sarake menu">{{ sarake.nimi }}</app-button>
      }
      <!-- <button mat-icon-button [matMenuTriggerFor]="sarakeMenu" [matMenuTriggerData]="{sarake: sarake}" (click)="$event.stopPropagation()">
  <mat-icon>more_horiz</mat-icon>
</button> -->
    </div>

    <div>
      <app-button (click)="lisaaSarake()" actionId="Lisää uusi sarake (asiakkaat listaus)" additionalClass="light-blue-text" matIcon="add"> Lisää sarake </app-button>
      @if (naytaOmaVaiToisenKirjanpitajanSarakkeetValintaObservable | async) {
        <span>
          Näkyvät sarakkeet
          <span>
            <mat-radio-group [formField]="sarakkeidenValintaLomake.omatVaiKirjanpitajanSarakkeet" style="margin-left: 10px">
              <mat-radio-button value="o">Omat</mat-radio-button>
              <mat-radio-button value="k" style="margin-left: 10px">Kirjanpitajan</mat-radio-button>
            </mat-radio-group>
          </span>
        </span>
      }
    </div>
  </div>
}

@if (korttisuodatusObservable | async; as korttisuodatus) {
  <app-korttisuodatuksen-indikaattori [suodatus]="korttisuodatus" [asiakkaita]="(indikaattorinAsiakasmaaraObservable | async) ?? 0" (poista)="poistaKorttisuodatus()"></app-korttisuodatuksen-indikaattori>
}

<mat-paginator style="margin-top: 15px; margin-left: 15px" pageSize="200" [pageSizeOptions]="[100, 200, 400, 1000, 10000]"></mat-paginator>

<table class="a-l-table" matSort matSortActive="nimi" matSortDirection="asc" [style.min-width]="minwidthObservable | async">
  <thead class="light-blue-text">
    <tr class="a-l-r-tr">
      <th mat-sort-header="synkronoi" style="width: 50px; max-width: 50px; min-width: 50px; vertical-align: bottom; padding: 0"></th>
      @if (onkoKehittajaObservable | async) {
        <th mat-sort-header="asiakasId" class="a-l-r-td-eka" style="width: 60px; max-width: 60px; min-width: 60px; vertical-align: bottom; padding: 0">id</th>
      }
      <th mat-sort-header="hinta" class="a-l-r-td-eka" style="width: 75px; max-width: 75px; min-width: 75px; vertical-align: bottom; padding: 0">Hinta</th>
      <th mat-sort-header="nimi" class="a-l-r-td-toka" style="min-width: 250px; width: 250px; max-width: 250px; vertical-align: bottom">Nimi</th>
      @for (sarake of aktiivisetSarakkeetObservable | async; track sarake.avain) {
        <th [mat-sort-header]="sarake.avain" class="a-l-r-td-sarake" style="min-width: 75px; width: 75px; max-width: 75px; vertical-align: bottom">{{ sarake.nimi }}</th>
      }
      <th class="a-l-r-td-toka" style="min-width: 100px; max-width: 250px; vertical-align: bottom">Lisä-<br />palvelut</th>
      <th mat-sort-header="yritysmuoto" class="a-l-r-td-kolmas" style="width: 65px; max-width: 65px; min-width: 65px; vertical-align: bottom">Yritys-<br />muoto</th>
      <th mat-sort-header="alvjakso" class="a-l-r-td-neljas" style="width: 60px; max-width: 60px; min-width: 60px; vertical-align: bottom">Alv-<br />jakso</th>
      @for (kuukausi of kuukaudetObservable | async; track kuukausi.year * 100 + kuukausi.month) {
        <th style="width: 50px; max-width: 50px; min-width: 50px; vertical-align: bottom" class="a-l-r-td-ruutu">
          <span class="light-gray-text" style="font-size: 90%; font-weight: normal">{{ kuukausi.year }}</span
          ><br />
          <span style="font-size: 190%">{{ kuukausi.month > 9 ? kuukausi.month : '0' + kuukausi.month }}</span>
          <div style="position: relative; width: 50px">
            <span [style.width]="kuukausi.valmiusaste + '%'" style="height: 20px; display: block; background-color: rgb(119, 215, 91)"></span>
            <span style="font-weight: normal; font-size: 80%; position: absolute; top: 0; left: 0; bottom: 0; right: 0; color: rgba(0, 0, 0, 0.87)"> {{ kuukausi.valmiusasteMuotoiltu }}% </span>
          </div>
        </th>
      }
      <th mat-sort-header="verotilinsaldo" class="a-l-r-td-viides" style="width: 110px; max-width: 110px; min-width: 110px; vertical-align: bottom; padding: 0">Verotilin saldo</th>
      <th class="a-l-r-td-kuudes" style="display: table-cell; vertical-align: bottom; min-width: 200px">Muistiinpanot</th>
    </tr>
  </thead>
  @if (kuukaudetObservable | async; as kuukaudet) {
    <tbody>
      @for (asiakas of asiakkaatObservable | async; track asiakas.k) {
        <tr (click)="kayttajatJaTositteet(asiakas)" [class]="asiakas.luokat">
          <td style="text-align: center; width: 50px; height: 20px; overflow: hidden">
            @if (asiakas.synkronoi) {
              <mat-spinner diameter="40"></mat-spinner>
            }
            @if (asiakas.bsf) {
              <img src="/assets/suomifi.svg" title="Suomi.fi -valtuutus puuttuu" style="background-color: rgb(0, 52, 121); display: inline-block; width: 11px; height: 11px; padding: 2px" />
            }
            @if (asiakas.sopimusHyvaksymatta) {
              <i title="Sopimus hyväksymättä" class="fa fa-pencil-square" style="font-size: 20px; padding: 1px; color: red"></i>
            }
            @if (asiakas.palaveriPitamatta) {
              <i title="Palaveri pitämättä" class="fa fa-phone-square" style="font-size: 20px; padding: 1px; color: orange"></i>
            }
            @if (asiakas.pankkiyhteysPuuttuu) {
              <i title="Pankkiyhteys puuttuu" class="fa fa-chain-broken gray-text" style="font-size: 20px; padding: 1px"></i>
            }
            @if (asiakas.pankkiyhteysEiOleLisattyMaksutapoihin) {
              <i title="Pankkiyhteys ei ole lisätty maksutapoihin" class="fa fa-chain-broken" style="font-size: 20px; padding: 1px; color: orange"></i>
            }
            @if (asiakas.riskiarvioTekematta) {
              <i title="Riskiarvio tekemättä!" class="fa fa-user-secret" style="font-size: 20px; padding: 1px" [style.color]="asiakas.edustajaTunnistamatta ? 'red' : 'black'"></i>
            }
            @if (asiakas.alv && !asiakas.bsf) {
              <i [title]="'Omaverossa ALV-jakso on ' + (asiakas.alv === 'ei' ? 'Ei verovelvollinen' : asiakas.alv) + '!'" class="fa fa-bomb" style="font-size: 25px; padding: 1px; color: black"></i>
            }
            @if (asiakas.ytj) {
              <img src="/assets/ytj-logo.png" title="YTJ-tiedot muuttuneet" style="background-color: transparent; display: inline-block; height: 11px; padding: 2px" />
            }
            @if (asiakas.tm) {
              <i title="Tauon muistutus!" class="icon ion-ios-alarm" style="font-size: 20px; padding: 1px; color: red" (click)="openTaukoMuistutusDialog(asiakas.k, $event)"></i>
            }
            @if (asiakas.myt) {
              <mat-icon title="Käyttäjä moniyritystuessa" style="font-size: 20px; width: 20px; height: 20px; padding: 1px; vertical-align: middle">switch_account</mat-icon>
            }
          </td>
          @if (onkoKehittajaObservable | async) {
            <td class="a-l-r-td-eka">{{ asiakas.i }}</td>
          }
          <td class="a-l-r-td-eka">
            @if (asiakas.st === 'v') {
              <span title="Sopimus voimassa">{{ asiakas.h }}</span>
            }
            @if (asiakas.st === 'pa') {
              <span title="Sopimus päättynyt" class="asiakaslista-ikoni ion-ios-close-circle-outline"></span>
            }
            @if (asiakas.st === 'p') {
              <span title="Sopimus päättymässä" class="asiakaslista-ikoni ion-ios-close-circle-outline blink-asiakaslista-x"></span>
            }
            @if (asiakas.st === 'pu') {
              <span title="Sopimus purettu" style="background-color: black; border-radius: 50%; width: 22px; height: 22px" class="asiakaslista-ympyra"></span>
              <span title="Sopimus purettu" style="color: white; font-size: 13px; font-weight: bold" class="asiakaslista-ympyra-kirjain">X</span>
            }
            @if (asiakas.st === 't') {
              <span title="Sopimus tauolla" class="ion-ios-radio-button-off asiakaslista-ympyra"></span>
              <span title="Sopimus tauolla" class="asiakaslista-ympyra-kirjain">T</span>
            }
            @if (asiakas.st === 'pl') {
              <span title="Pöytälaatikko" class="ion-ios-radio-button-off asiakaslista-ympyra"></span>
              <span title="Pöytälaatikko" class="asiakaslista-ympyra-kirjain">P</span>
            }
            @if (asiakas.st === 'a') {
              <span title="Sopimus allekirjoittamatta" class="ion-ios-radio-button-off asiakaslista-ympyra"></span>
              <i title="Sopimus allekirjoittamatta" class="fa fa-pencil asiakaslista-ympyra-ikoni" aria-hidden="true"></i>
            }
          </td>
          <td class="a-l-r-td-toka">
            @if (asiakas.tk) {
              <mat-icon class="red-text" style="vertical-align: middle; margin-right: 4px" matTooltip="Työkielto!">block</mat-icon>
            }
            {{ asiakas.n }}
          </td>
          @for (sarake of asiakas.sarakkeet; track sarake.sarakeAvain) {
            <td [class]="'a-l-r-td-sarake ' + sarake.luokka" (click)="muokkaaSarakeSolua($event, asiakas, sarake)">{{ sarake.arvo }}</td>
          }
          <td class="a-l-r-td-toka" style="text-align: center">
            @if (asiakas.lp?.p) {
              <i matTooltip="Palkkapalvelu" class="lisapalv-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="lisapalv-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: none; stroke: currentColor; stroke-linejoin: round; stroke-width: 32px">
                  <rect x="48" y="144" width="416" height="288" rx="48" ry="48" />
                  <path d="M411.36,144V114A50,50,0,0,0,352,64.9L88.64,109.85A50,50,0,0,0,48,159v49" />
                  <path d="M368,320a32,32,0,1,1,32-32A32,32,0,0,1,368,320Z" style="fill: currentColor" />
                </svg>
              </i>
            }
            @if (asiakas.lp?.es) {
              <i matTooltip="Ennakkoverojen seuranta" class="lisapalv-icon icon ion-ios-pizza-outline"></i>
            }
            @if (asiakas.lp?.lv && !asiakas.lp?.lm) {
              <i matTooltip="Laskujen vastaanotto" class="lisapalv-icon icon ion-ios-flash-outline" style="font-size: 28px"></i>
            }
            @if (asiakas.lp?.lm) {
              <i matTooltip="Laskujen maksaminen" class="lisapalv-icon icon ion-ios-flash"></i>
            }
          </td>
          <td class="a-l-r-td-kolmas">{{ asiakas.yritysmuoto }}</td>
          <td class="a-l-r-td-neljas">{{ asiakas.alvIlmoitusjakso }}</td>
          @for (kuukausi of asiakas.kuukaudet; track kuukausi.k) {
            <td class="a-l-r-td-ruutu" (click)="clickRuutu($event, asiakas, kuukausi)" (contextmenu)="openContextMenu($event, contextMenuTrigger, spanTrigger, asiakas, kuukausi)" [class]="kuukausi.luokat">
              <span class="a-l-r-s-a1"></span>
              <span class="a-l-r-s-a2">{{ kuukausi.vasenAlakulma }}</span>
              <span class="a-l-r-s-a3">
                <i class="fa fa-comment" [title]="kuukausi.m"></i>
              </span>
              <span class="a-l-r-s-a4">{{ kuukausi.oikeaAlakulma }}</span>
              <!-- <span class="a-l-r-s-a5"></span> -->
              <span class="a-l-r-s-a6"></span>
            </td>
          }
          <td class="a-l-r-td-viides">
            <div class="a-l-r-td-viides-c">
              <div class="a-l-r-td-viides-h">{{ asiakas?.r }}</div>
              <div class="a-l-r-td-viides-s">{{ asiakas?.omaverosaldo }}</div>
              <div class="a-l-r-td-viides-m">Huomioitavaa!</div>
            </div>
          </td>
          <td class="a-l-r-td-kuudes" (click)="muokkaaMuistiinpanoja($event, asiakas)">{{ asiakas?.m }}</td>
        </tr>
      }
    </tbody>
  }
</table>

@if (listauksenSummatiedotObservable | async; as summaustiedot) {
  <div style="line-height: 50px; color: rgb(185, 185, 185); font-size: 13px; padding-left: 10px">
    <span style="padding-right: 20px">Asiakkaita {{ summaustiedot.asiakkaita }}</span>
    <!-- <span style="padding-right: 20px;">Veloitus {{ summaustiedot.veloitus | lmoney | async }}</span>
    <span>Keskihinta {{ summaustiedot.keskihinta | lmoney | async }}</span> -->
  </div>
}

@if (!(lataaObservable | async) && (asiakkaidenLukumaaraObservable | async) === 0) {
  <div class="table-ladataan" style="width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
    <div style="width: 100%; padding-top: 40px; text-align: center">
      {{ 'asiakkaat.hakuehdoilla-ei-yhtaan-tulosta' | translate | async }}
    </div>
  </div>
}
@if (lataaObservable | async) {
  <div style="position: relative; width: 100%; height: 200px">
    <div lemon-loading [show]="lataaObservable | async"></div>
  </div>
}

<form style="margin: 2em; display: flex; flex-flow: row wrap" novalidate>
  <mat-form-field style="margin-right: 2em; min-width: 220px; max-width: 300px; width: 30%">
    <mat-label>Lataa listalla näkyvien asiakkaiden</mat-label>
    <mat-select [formField]="latausLomake.latauslaajuus">
      <mat-option [value]="1">Laskutusosoitteet</mat-option>
      <mat-option [value]="2">Käyttäjien osoitteet</mat-option>
      <mat-option [value]="3">Kaikki osoitteet</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="lisaa-nappula-container" style="align-self: flex-start">
    <app-primary-button (click)="annaKaikkienKayttajienSahkopostiosoitteet()" actionId="Lataa kaikkien käyttäjien sähköpostiosoitteet koneelle" additionalClass="mat-elevation-z4"> Lataa tiedot </app-primary-button>
  </div>
</form>

<span #contextMenuTrigger="matMenuTrigger" #spanTrigger [matMenuTriggerFor]="kuukausiMenu" style="position: fixed"></span>
<mat-menu #kuukausiMenu="matMenu">
  <ng-template matMenuContent let-kuukausi="kuukausi" let-asiakas="asiakas">
    <app-menu-item-button (click)="avaaKuukausistatus($event, asiakas, kuukausi)" actionId="Kuukausiruutu: Avaa muokkaa yksityiskohtia dialog">Muokkaa yksityiskohtia</app-menu-item-button>
    <app-menu-item-button (click)="avaaUudessaIkkunassa($event, asiakas, kuukausi)" actionId="Kuukausiruutu: Avaa uudessa ikkunassa">Avaa uudessa ikkunassa</app-menu-item-button>
  </ng-template>
</mat-menu>

<span #sarakeContextMenuTrigger="matMenuTrigger" #sarakeMenuTrigger [matMenuTriggerFor]="sarakeMenu" style="position: fixed"></span>
<mat-menu #sarakeMenu="matMenu">
  <ng-template matMenuContent let-sarake="sarake">
    <app-menu-item-button (click)="siirraSarakeOikealle($event, sarake)" actionId="Siirrä sarake oikealle">Siirrä oikealle</app-menu-item-button>
    <app-menu-item-button (click)="siirraSarakeVasemmalle($event, sarake)" actionId="Siirrä sarake vasemmalle">Siirrä vasemmalle</app-menu-item-button>
    <app-menu-item-button (click)="tyhjennaSarake($event, sarake)" actionId="Avasi dialogin: Tyhjennä sarake">Tyhjennä sarake</app-menu-item-button>
    <app-menu-item-button (click)="poistaSarake($event, sarake)" actionId="Avasi dialogin: Poista sarake">Poista sarake</app-menu-item-button>
  </ng-template>
</mat-menu>

@if (this.kirjanpitajaOnHallintoTaiLuottoObservable | async) {
  <app-primary-button (click)="hallintoon()" actionId="Navigoi Lemon Treen laskuihin (hallinto)"> Hallinto / Laskut </app-primary-button>
}
